(function () {
  'use strict';

  var ROOT_SEL = '.x60-puc-suction';
  var PC_MIN = 850.1;
  var ST_ID = 'x60-puc-suction-pc-pin';
  var scrollTriggerInstance = null;
  var timelineInstance = null;
  var initialized = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function isDesktop() {
    return window.innerWidth > PC_MIN;
  }

  function isRootInView(root) {
    if (!root) return false;
    var rect = root.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (rect.bottom <= 0 || rect.top >= vh) return false;
    var visibleHeight = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
    return visibleHeight > Math.min(rect.height * 0.12, vh * 0.1);
  }

  function playSuctionVideos(root) {
    if (!root || !isRootInView(root)) return;

    root.querySelectorAll('.x60-puc-suction__video').forEach(function (video) {
      var host = video.closest('.x60-puc-suction__pc, .x60-puc-suction__mb');
      if (!host) return;
      if (host.classList.contains('x60-puc-suction__pc') && !isDesktop()) return;
      if (host.classList.contains('x60-puc-suction__mb') && isDesktop()) return;

      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      if (video.paused) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      }
    });
  }

  function initVideos() {
    var root = document.querySelector(ROOT_SEL);
    if (!root) return;
    playSuctionVideos(root);
  }

  function destroy() {
    initialized = false;

    if (scrollTriggerInstance) {
      scrollTriggerInstance.kill();
      scrollTriggerInstance = null;
    }
    if (timelineInstance) {
      timelineInstance.kill();
      timelineInstance = null;
    }

    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.getAll().forEach(function (trigger) {
        if (trigger.vars && trigger.vars.id === ST_ID) {
          trigger.kill();
        }
      });
    }

    var root = document.querySelector(ROOT_SEL);
    if (!root) return;

    root.classList.remove('is-scroll-ready');

    var pinWrap = root.querySelector('.x60-puc-suction__pc-pin-wrap');
    if (pinWrap) {
      pinWrap.classList.remove('is-pinned');
    }

    [
      '.x60-puc-suction__pc-video-wrap',
      '.x60-puc-suction__pc-title',
      '.x60-puc-suction__pc-copy',
      '.x60-puc-suction__pc-overlay',
      '.x60-puc-suction__pc-overlay-bar',
    ].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (el) {
        el.removeAttribute('style');
      }
    });
  }

  function getVideoStageMetrics(videoWrap) {
    var body = videoWrap.closest('.x60-puc-suction__pc-body');
    var bodyW = body ? body.offsetWidth : window.innerWidth;
    var bodyH = body ? body.offsetHeight : window.innerHeight;
    return {
      bodyW: bodyW,
      bodyH: bodyH,
    };
  }

  function getCenteredVideoLeft(width, bodyW) {
    return (bodyW - width) / 2;
  }

  function getVideoTop(height, bodyH, topRatio, snapMode) {
    var top = bodyH * topRatio - height / 2;
    if (snapMode === 'floor') return Math.floor(top);
    if (snapMode === 'ceil') return Math.ceil(top);
    return Math.round(top);
  }

  function snapPx(value) {
    return Math.round(value);
  }

  function getStageWidth(videoWrap) {
    var body = videoWrap.closest('.x60-puc-suction__pc-body');
    var stage = videoWrap.closest('.x60-puc-suction__pc-stage');
    if (body && body.offsetWidth) return body.offsetWidth;
    if (stage && stage.offsetWidth) return stage.offsetWidth;
    return document.documentElement.clientWidth || window.innerWidth;
  }

  function init() {
    if (initialized || !isDesktop()) {
      return;
    }

    var root = document.querySelector(ROOT_SEL);
    if (!root || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return;
    }

    var pinWrap = root.querySelector('.x60-puc-suction__pc-pin-wrap');
    var title = root.querySelector('.x60-puc-suction__pc-title');
    var videoWrap = root.querySelector('.x60-puc-suction__pc-video-wrap');
    var overlay = root.querySelector('.x60-puc-suction__pc-overlay');
    var overlayBar = root.querySelector('.x60-puc-suction__pc-overlay-bar');
    var copy = root.querySelector('.x60-puc-suction__pc-copy');

    if (!pinWrap || !videoWrap || !copy) {
      return;
    }

    initialized = true;
    root.classList.add('is-scroll-ready');
    gsap.registerPlugin(ScrollTrigger);

    var metrics = getVideoStageMetrics(videoWrap);
    var initialWidth = snapPx(videoWrap.offsetWidth);
    var initialHeight = snapPx(videoWrap.offsetHeight);
    var viewportW = getStageWidth(videoWrap);
    var viewportH = metrics.bodyH || window.innerHeight;

    if (!initialWidth) {
      initialWidth = snapPx(Math.min(calcMaxVideoWidth(), viewportW - 48));
    }
    if (!initialHeight) {
      initialHeight = snapPx(initialWidth * 0.5);
    }

    var aspectRatio = initialHeight / initialWidth;
    var finalWidth = snapPx(viewportW);
    var finalHeight = Math.ceil(finalWidth * aspectRatio);
    var borderRadiusStart = 8;
    var topStart = 0.58;
    var topEnd = 0.5;
    var leftStart = snapPx(getCenteredVideoLeft(initialWidth, metrics.bodyW));
    var leftEnd = snapPx(getCenteredVideoLeft(finalWidth, metrics.bodyW));
    var topStartPx = getVideoTop(initialHeight, metrics.bodyH, topStart, 'round');
    var topEndPx = getVideoTop(finalHeight, metrics.bodyH, topEnd, 'floor');

    gsap.set(copy, {
      xPercent: -50,
      yPercent: 100,
      opacity: 0,
    });

    if (overlay) {
      gsap.set(overlay, { opacity: 0 });
    }
    if (overlayBar) {
      gsap.set(overlayBar, { opacity: 0 });
    }

    gsap.set(videoWrap, {
      left: leftStart,
      top: topStartPx,
      x: 0,
      y: 0,
      xPercent: 0,
      yPercent: 0,
      width: initialWidth,
      height: initialHeight,
      borderRadius: borderRadiusStart,
      transformOrigin: '50% 50%',
    });

    var scrollDistance = viewportH * 2.2;

    timelineInstance = gsap.timeline({
      scrollTrigger: {
        id: ST_ID,
        trigger: pinWrap,
        start: 'center center',
        end: '+=' + scrollDistance,
        pin: pinWrap,
        scrub: true,
        anticipatePin: 0,
        invalidateOnRefresh: true,
        onRefresh: function () {
          if (!timelineInstance) return;
          var m = getVideoStageMetrics(videoWrap);
          var w = gsap.getProperty(videoWrap, 'width');
          var h = gsap.getProperty(videoWrap, 'height');
          var progress = timelineInstance.progress();
          var currentW = snapPx(typeof w === 'number' ? w : initialWidth);
          var currentH = snapPx(typeof h === 'number' ? h : initialHeight);
          var topRatio = topStart + (topEnd - topStart) * Math.min(progress / 0.32, 1);
          var snapMode = progress >= 0.32 ? 'floor' : 'round';
          gsap.set(videoWrap, {
            left: snapPx(getCenteredVideoLeft(currentW, m.bodyW)),
            top: getVideoTop(currentH, m.bodyH, topRatio, snapMode),
            width: currentW,
            height: currentH,
          });
        },
        onEnter: function () {
          pinWrap.classList.add('is-pinned');
        },
        onEnterBack: function () {
          pinWrap.classList.add('is-pinned');
        },
        onLeave: function () {
          pinWrap.classList.remove('is-pinned');
        },
        onLeaveBack: function () {
          pinWrap.classList.remove('is-pinned');
        },
      },
    });

    if (title) {
      timelineInstance.fromTo(
        title,
        { opacity: 1, y: 0 },
        { opacity: 0, y: '-8%', duration: 0.32, ease: 'none' },
        0
      );
    }

    timelineInstance.fromTo(
      videoWrap,
      {
        width: initialWidth,
        height: initialHeight,
        left: leftStart,
        top: topStartPx,
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        borderRadius: borderRadiusStart,
        immediateRender: true,
      },
      {
        width: finalWidth,
        height: finalHeight,
        left: leftEnd,
        top: topEndPx,
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        borderRadius: 0,
        duration: 0.32,
        ease: 'none',
        force3D: true,
        roundProps: 'width,height,left,top',
      },
      0
    );

    if (overlay) {
      timelineInstance.fromTo(
        overlay,
        { opacity: 0 },
        { opacity: 1, duration: 0.32, ease: 'none' },
        0
      );
    }
    if (overlayBar) {
      timelineInstance.fromTo(
        overlayBar,
        { opacity: 0 },
        { opacity: 1, duration: 0.32, ease: 'none' },
        0
      );
    }

    timelineInstance.fromTo(
      copy,
      { xPercent: -50, yPercent: 100, opacity: 0 },
      { xPercent: -50, yPercent: 0, opacity: 1, duration: 0.68, ease: 'none' },
      0.32
    );

    scrollTriggerInstance = timelineInstance.scrollTrigger;
    if (scrollTriggerInstance) {
      scrollTriggerInstance.refresh();
    }

    initVideos();
  }

  function setup() {
    destroy();
    if (!isDesktop()) {
      return;
    }
    init();
  }

  function calcMaxVideoWidth() {
    var px = window.innerWidth / 1920;
    return Math.min(1200 * px, window.innerWidth - 48);
  }

  ready(function () {
    initVideos();
    [200, 600, 1200].forEach(function (delay) {
      window.setTimeout(initVideos, delay);
    });

    window.addEventListener(
      'scroll',
      function () {
        initVideos();
      },
      { passive: true }
    );

    if (!isDesktop()) {
      return;
    }

    if (typeof triggerResizeOnEnterViewport === 'function') {
      triggerResizeOnEnterViewport(ROOT_SEL, setup);
    } else {
      setup();
    }
  });

  if (typeof resizeCustomFn === 'function') {
    resizeCustomFn(function () {
      setup();
    });
  } else {
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 200);
    });
  }
})();
